<template>
    <ModalBasic :modal-id="modalId" title="Reçu de paiement">
        <div class="revolut-qr-modal">
            <p class="revolut-qr-modal__hint">
                Scannez ce QR code avec votre téléphone pour récupérer le reçu de paiement&nbsp;:
            </p>

            <div class="revolut-qr-modal__qr" v-if="qrDataUrl">
                <img :src="qrDataUrl" alt="QR code du reçu" />
            </div>
            <div v-else class="revolut-qr-modal__qr-loading">
                <span class="obloader small"></span>
            </div>

            <p class="revolut-qr-modal__or">— ou —</p>

            <a
                class="revolut-qr-modal__link"
                :href="receiptUrl"
                target="_blank"
                rel="noopener noreferrer"
            >
                Ouvrir le reçu dans un nouvel onglet
            </a>
        </div>
    </ModalBasic>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import QRCode from 'qrcode'
import * as Sentry from '@sentry/browser'
import ModalBasic from '@/components/molecules/modal/ModalBasic.vue'

const props = defineProps<{
    modalId: symbol | string
    receiptUrl: string
}>()

const qrDataUrl = ref<string>('')

const generateQr = async (url: string) => {
    if (!url) {
        qrDataUrl.value = ''
        return
    }
    try {
        qrDataUrl.value = await QRCode.toDataURL(url, {
            width: 320,
            margin: 1,
            color: { dark: '#000000', light: '#FFFFFF' },
        })
    } catch (err) {
        Sentry.captureException(err)
        qrDataUrl.value = ''
    }
}

watch(
    () => props.receiptUrl,
    (url) => generateQr(url),
    { immediate: true }
)
</script>

<style scoped>
.revolut-qr-modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
    padding: 1rem 0;
}
.revolut-qr-modal__hint {
    text-align: center;
    font-size: 1.5rem;
    margin: 0;
}
.revolut-qr-modal__qr,
.revolut-qr-modal__qr-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    padding: 1rem;
    border-radius: 12px;
    min-width: 280px;
    min-height: 280px;
}
.revolut-qr-modal__qr img {
    display: block;
    width: 280px;
    height: 280px;
}
.revolut-qr-modal__or {
    color: #b0b0b0;
    font-size: 1.4rem;
    margin: 0;
}
.revolut-qr-modal__link {
    color: #ffc941;
    text-decoration: underline;
    font-size: 1.6rem;
    font-weight: 600;
}
</style>
